<template>
    <v-app>
        <AppLoader/>
    </v-app>
</template>

<script>
    import AppLoader from "./components/AppLoader";
    export default {
        name: "App",
        components: {AppLoader}
    }
</script>

<style scoped>

</style>
